
const courseGroups = {
    en: [
        {
            title: 'Starter',
            desc: 'Embark on Your Korean Language Learning Journey: Beginning with ㄱ, ㄴ, ㄷ!',
        },
        {
            title: 'Beginner',
            desc: 'Build your Korean foundations for solid language skills!',
        },
        {
            title: 'Intermediate',
            desc: 'Level up your Korean skills and speak with confidence!',
        },
        {
            title: 'Advanced',
            desc: 'Master advanced Korean grammar for fluent communication!',
        }
    ],
    ja: [
        {
            title: 'スターター',
            desc: 'あなたの韓国語学習の旅を始めよう：ㄱ、ㄴ、ㄷから！',
        },
        {
            title: '初心者',
            desc: 'しっかりした言語スキルのための韓国語基礎を築こう！',
        },
        {
            title: '中級',
            desc: '韓国語のスキルを向上させ、自信を持って話しましょう！',
        },
        {
            title: '上級',
            desc: '流暢なコミュニケーションのために上級の韓国語文法をマスターしましょう！',
        }
    ],
    vi: [
        {
            title: 'Người mới bắt đầu',
            desc: 'Bắt đầu hành trình học tiếng Hàn của bạn: Bắt đầu với ㄱ, ㄴ, ㄷ!',
        },
        {
            title: 'Người mới bắt đầu',
            desc: 'Xây dựng nền tảng tiếng Hàn của bạn để có kỹ năng ngôn ngữ vững chắc!',
        },
        {
            title: 'Trung cấp',
            desc: 'Nâng cao kỹ năng tiếng Hàn của bạn và nói chuyện một cách tự tin!',
        },
        {
            title: 'Nâng cao',
            desc: 'Thạo thành thạo ngữ pháp tiên tiến tiếng Hàn để giao tiếp lưu loát!',
        }
    ],
    es: [
        {
            title: 'Inicio',
            desc: '¡Emprende tu viaje de aprendizaje del idioma coreano: ¡Comenzando con ㄱ, ㄴ, ㄷ!',
        },
        {
            title: 'Principiante',
            desc: '¡Construye tus bases en coreano para habilidades lingüísticas sólidas!',
        },
        {
            title: 'Intermedio',
            desc: '¡Mejora tus habilidades en coreano y habla con confianza!',
        },
        {
            title: 'Avanzado',
            desc: '¡Domina la gramática avanzada del coreano para una comunicación fluida!',
        }
    ],
    id: [
        {
            title: 'Pemula',
            desc: 'Mulai perjalanan belajar bahasa Korea Anda: Dimulai dengan ㄱ, ㄴ, ㄷ!',
        },
        {
            title: 'Pemula',
            desc: 'Bangun dasar-dasar bahasa Korea Anda untuk keterampilan bahasa yang kuat!',
        },
        {
            title: 'Menengah',
            desc: 'Tingkatkan keterampilan bahasa Korea Anda dan bicaralah dengan percaya diri!',
        },
        {
            title: 'Lanjutan',
            desc: 'Kuasai tata bahasa Korea tingkat lanjutan untuk komunikasi lancar!',
        }
    ],
    ru: [
        {
            title: 'Новичок',
            desc: 'Начните свой путь обучения корейскому языку: Начните с ㄱ, ㄴ, ㄷ!',
        },
        {
            title: 'Новичок',
            desc: 'Постройте основы корейского языка для надежных языковых навыков!',
        },
        {
            title: 'Средний',
            desc: 'Повысьте свой уровень владения корейским языком и говорите с уверенностью!',
        },
        {
            title: 'Продвинутый',
            desc: 'Овладейте продвинутой грамматикой корейского языка для беглого общения!',
        }
    ],
    ar: [
        {
            title: 'بداية',
            desc: 'انطلق في رحلتك لتعلم اللغة الكورية: بدايةً من ㄱ، ㄴ، ㄷ!',
        },
        {
            title: 'مبتدئ',
            desc: 'ابن قواعدك في الكورية للحصول على مهارات لغوية قوية!',
        },
        {
            title: 'متوسط',
            desc: 'قم بتطوير مهاراتك في اللغة الكورية وتحدث بثقة!',
        },
        {
            title: 'متقدم',
            desc: 'اتقن قواعد اللغة الكورية المتقدمة للتواصل اللين!',
        }
    ],
    zh: [
        {
            title: '初学者',
            desc: '开启你的韩语学习之旅：从ㄱ、ㄴ、ㄷ开始！',
        },
        {
            title: '初学者',
            desc: '打造坚实的语言技能，建立您的韩语基础！',
        },
        {
            title: '中级',
            desc: '提升你的韩语技能，自信地说话！',
        },
        {
            title: '高级',
            desc: '掌握高级韩语语法，流利沟通！',
        }
    ],
    fr: [
        {
            title: 'Débutant',
            desc: 'Lancez-vous dans votre voyage d\'apprentissage de la langue coréenne : Commencez par ㄱ, ㄴ, ㄷ !',
        },
        {
            title: 'Débutant',
            desc: 'Construisez vos bases en coréen pour des compétences linguistiques solides !',
        },
        {
            title: 'Intermédiaire',
            desc: 'Améliorez vos compétences en coréen et parlez avec confiance !',
        },
        {
            title: 'Avancé',
            desc: 'Maîtrisez la grammaire coréenne avancée pour une communication fluide !',
        }
    ],
    mn: [
        {
            title: 'Эхлэгч',
            desc: 'Таны корей хэл сурах аяллыг эхлүүл: ㄱ, ㄴ, ㄷ -р эхлээд!',
        },
        {
            title: 'Эхлэгч',
            desc: 'Хэлний тодорхойлолтыг тогтооно уу!',
        },
        {
            title: 'Дунд',
            desc: 'Корей хэлний мэргэжилтэй болохыг хичээнэ уу, итгэлтэй яриарай!',
        },
        {
            title: 'Урт',
            desc: 'Урт хэлний хэлний бичиг баримтлалыг ажиллаарай!',
        }
    ],
    th: [
        {
            title: 'มือใหม่',
            desc: 'เริ่มการเรียนรู้ภาษาเกาหลีของคุณ: ขึ้นต้นด้วย ㄱ, ㄴ, ㄷ!',
        },
        {
            title: 'มือใหม่',
            desc: 'สร้างพื้นฐานภาษาเกาหลีของคุณเพื่อทักษะภาษาที่มั่นคง!',
        },
        {
            title: 'ปานกลาง',
            desc: 'พัฒนาทักษะภาษาเกาหลีของคุณและพูดด้วยความมั่นใจ!',
        },
        {
            title: 'ขั้นสูง',
            desc: 'เรียนรู้ไวยากรณ์เกาหลีขั้นสูงสำหรับการสื่อสารอย่างคล่องแคล่ว!',
        }
    ],
};

const courseContents = {
    en: [
        {
            title: 'Hello, Korean!',
            desc: 'Get a fun introduction to Hangeul, the Korean alphabet, and learn basic structure of Korean grammar to kickstart your Korean language learning journey.'
        },
        {
            title: 'Grammar Foundations 101',
            desc: 'Build a solid foundation in Korean grammar with essential language structures, verbs, and basic sentence patterns.',
        },
        {
            title: 'Breaking Beginner\'s Barrier',
            desc: 'Advanced grammar concepts, vocabulary, and sentence construction techniques to overcome the beginner\'s grammar barrier.',
        },
        {
            title: 'Beyond Basics, Conquer Korean!',
            desc: 'In-depth study of complex grammar patterns, sentence variations, and practical language usage for greater fluency.',
        },
        {
            title: 'Mastering Complex Structures',
            desc: 'Master complex grammar structures, advanced verbs, and nuanced language expressions for confident communication.',
        },
        {
            title: 'Fluent and Flawless Grammar',
            desc: 'Polish grammar skills for fluency with advanced usage, nuances, and refined expressions.',
        },
        {
            title: 'Be a Grammar Master',
            desc: 'Expertise in Korean grammar with advanced language constructions, nuances for professional and academic contexts.',
        }
    ],
    ja: [
        {
            title: 'こんにちは、韓国語！',
            desc: '楽しいハングル入門を始めて、韓国語のアルファベットであるハングルを学び、韓国語の文法の基本構造を身に付け、韓国語学習の旅をスタートさせましょう。',
        },
        {
            title: '文法基礎 101',
            desc: '韓国語の文法にしっかりした基礎を築き、重要な言語構造、動詞、基本的な文パターンを身に付けましょう。',
        },
        {
            title: '初心者の壁を打ち破る',
            desc: '初心者の文法の障壁を克服するための高度な文法概念、語彙、および文構築技術。',
        },
        {
            title: '基本を超えて、韓国語を制覇しよう！',
            desc: '複雑な文法パターン、文の変化、そしてより流暢なための実用的な言語使用の徹底的な研究。',
        },
        {
            title: '複雑な構造の習得',
            desc: '自信を持ってコミュニケーションを取るために、複雑な文法構造、高度な動詞、微妙な言語表現をマスターします。',
        },
        {
            title: '流暢かつ完璧な文法',
            desc: '上級の使用法、ニュアンス、洗練された表現による流暢なポーランド語文法スキル。',
        },
        {
            title: '文法マスターになる',
            desc: 'プロフェッショナルおよびアカデミックなコンテキストでの高度な言語構築、微妙なニュアンスを持つ韓国語文法の専門知識。',
        }
    ],
    vi: [
        {
            title: 'Xin chào, tiếng Hàn!',
            desc: 'Bắt đầu với một lời giới thiệu vui vẻ về Hangeul, bảng chữ cái của Hàn Quốc, và học cấu trúc cơ bản của ngữ pháp Hàn Quốc để bắt đầu hành trình học tiếng Hàn của bạn.',
        },
        {
            title: 'Nền tảng ngữ pháp 101',
            desc: 'Xây dựng nền tảng vững chắc về ngữ pháp Hàn Quốc với cấu trúc ngôn ngữ cơ bản, động từ và mẫu câu cơ bản.',
        },
        {
            title: 'Vượt qua rào cản của người mới bắt đầu',
            desc: 'Các khái niệm ngữ pháp nâng cao, vốn từ vựng và kỹ thuật xây dựng câu để vượt qua rào cản ngữ pháp của người mới bắt đầu.',
        },
        {
            title: 'Vượt qua cơ bản, chinh phục tiếng Hàn!',
            desc: 'Nghiên cứu sâu sắc về các mẫu ngữ pháp phức tạp, các biến thể câu, và việc sử dụng ngôn ngữ thực tế để nói lưu loát hơn.',
        },
        {
            title: 'Nắm vững Cấu trúc Phức tạp',
            desc: 'Nắm vững cấu trúc ngữ pháp phức tạp, động từ tiên tiến và biểu hiện ngôn ngữ tinh tế để giao tiếp một cách tự tin.',
        },
        {
            title: 'Ngữ pháp lưu loát và hoàn hảo',
            desc: 'Kỹ năng ngữ pháp tiếng Ba Lan để nói lưu loát với cách sử dụng, sắc thái và diễn đạt tinh tế.',
        },
        {
            title: 'Trở thành một Chuyên gia Ngữ pháp',
            desc: 'Chuyên môn về ngữ pháp tiếng Hàn với cấu trúc ngôn ngữ tiên tiến, sắc thái cho các bối cảnh chuyên nghiệp và học thuật.',
        }
    ],
    es: [
        {
            title: '¡Hola, coreano!',
            desc: 'Obtén una introducción divertida a Hangeul, el alfabeto coreano, y aprende la estructura básica de la gramática coreana para comenzar tu viaje de aprendizaje del idioma coreano.',
        },
        {
            title: 'Fundamentos de gramática 101',
            desc: 'Construye una base sólida en gramática coreana con estructuras de lenguaje esenciales, verbos y patrones de oraciones básicos.',
        },
        {
            title: 'Rompiendo la barrera del principiante',
            desc: 'Conceptos avanzados de gramática, vocabulario y técnicas de construcción de oraciones para superar la barrera de la gramática del principiante.',
        },
        {
            title: '¡Más allá de lo básico, conquista el coreano!',
            desc: 'Estudio en profundidad de patrones de gramática complejos, variaciones de oraciones y uso práctico del lenguaje para una mayor fluidez.',
        },
        {
            title: 'Dominando Estructuras Complejas',
            desc: 'Domina estructuras gramaticales complejas, verbos avanzados y expresiones lingüísticas matizadas para una comunicación segura.',
        },
        {
            title: 'Gramática fluida y sin defectos',
            desc: 'Habilidades gramaticales en polaco para fluidez con uso avanzado, matices y expresiones refinadas.',
        },
        {
            title: 'Sé un Maestro de la Gramática',
            desc: 'Experto en gramática coreana con construcciones de lenguaje avanzadas, matices para contextos profesionales y académicos.',
        }
    ],
    id: [
        {
            title: 'Halo, bahasa Korea!',
            desc: 'Dapatkan pengenalan yang menyenangkan tentang Hangeul, alfabet Korea, dan pelajari struktur dasar tata bahasa Korea untuk memulai perjalanan belajar bahasa Korea Anda.',
        },
        {
            title: 'Dasar-dasar tata bahasa 101',
            desc: 'Bangun fondasi yang kuat dalam tata bahasa Korea dengan struktur bahasa yang penting, kata kerja, dan pola kalimat dasar.',
        },
        {
            title: 'Mengatasi Hambatan Pemula',
            desc: 'Konsep tata bahasa tingkat lanjut, kosakata, dan teknik konstruksi kalimat untuk mengatasi hambatan tata bahasa pemula.',
        },
        {
            title: 'Melampaui dasar, taklukkan bahasa Korea!',
            desc: 'Studi mendalam tentang pola tata bahasa kompleks, variasi kalimat, dan penggunaan bahasa yang praktis untuk kelancaran yang lebih besar.',
        },
        {
            title: 'Menguasai Struktur Kompleks',
            desc: 'Kuasai struktur tata bahasa kompleks, kata kerja tingkat lanjut, dan ekspresi bahasa yang rumit untuk komunikasi yang percaya diri.',
        },
        {
            title: 'Tata bahasa lancar dan sempurna',
            desc: 'Keterampilan tata bahasa Polandia untuk kelancaran dengan penggunaan lanjutan, nuansa, dan ekspresi yang disempurnakan.',
        },
        {
            title: 'Menjadi Master Tata Bahasa',
            desc: 'Keahlian dalam tata bahasa Korea dengan konstruksi bahasa lanjutan, nuansa untuk konteks profesional dan akademik.',
        }
    ],
    ru: [
        {
            title: 'Привет, корейский!',
            desc: 'Получите увлекательное введение в Хангыль, корейский алфавит, и изучите основные структуры корейской грамматики, чтобы начать свой путь в изучении корейского языка.',
        },
        {
            title: 'Основы грамматики 101',
            desc: 'Постройте прочный фундамент в корейской грамматике с основными языковыми структурами, глаголами и базовыми шаблонами предложений.',
        },
        {
            title: 'Преодоление барьера для начинающих',
            desc: 'Продвинутые концепции грамматики, словарный запас и техники построения предложений, чтобы преодолеть барьер начинающего в грамматике.',
        },
        {
            title: 'Превзойдите базовые знания, покорите корейский!',
            desc: 'Глубокое изучение сложных грамматических шаблонов, вариаций предложений и практического использования языка для более высокой беглости.',
        },
        {
            title: 'Овладение сложными структурами',
            desc: 'Овладейте сложными грамматическими структурами, продвинутыми глаголами и тонкими языковыми выражениями для уверенного общения.',
        },
        {
            title: 'Беглая и безупречная грамматика',
            desc: 'Грамматические навыки на польском языке для свободного общения с использованием продвинутых приемов, нюансов и изысканных выражений.',
        },
        {
            title: 'Будьте мастером грамматики',
            desc: 'Владение корейской грамматикой с продвинутыми языковыми конструкциями, нюансами для профессиональных и академических контекстов.',
        }
    ],
    ar: [
        {
            title: 'مرحبًا، الكورية!',
            desc: 'احصل على مقدمة ممتعة لهانجول، أبجدية اللغة الكورية، وتعلم الهيكل الأساسي لقواعد اللغة الكورية لبدء رحلتك في تعلم اللغة الكورية.',
        },
        {
            title: 'أسس القواعد 101',
            desc: 'قم ببناء أساس قوي في قواعد اللغة الكورية مع الهياكل اللغوية الأساسية والأفعال وأنماط الجمل الأساسية.',
        },
        {
            title: 'كسر حاجز المبتدئين',
            desc: 'مفاهيم قواعد متقدمة ومفردات وتقنيات بناء جمل متقدمة للتغلب على عائق قواعد المبتدئين.',
        },
        {
            title: 'ما وراء الأساسيات، اغزو الكورية!',
            desc: 'دراسة متعمقة لأنماط القواعد اللغوية المعقدة، والتغيرات في الجمل، واستخدام اللغة العملي لزيادة الليونة.',
        },
        {
            title: 'السيطرة على الهياكل المعقدة',
            desc: 'تقنّن هياكل القواعد المعقدة، الأفعال المتقدمة، والتعبيرات اللغوية المُعقّدة للتواصل بثقة.',
        },
        {
            title: 'قواعد لغوية سلسة وخالية من العيوب',
            desc: 'مهارات قواعد اللغة البولندية للانسيابية مع الاستخدام المتقدم والتفاصيل والتعبيرات المنقّاة.',
        },
        {
            title: 'كن سيد القواعد',
            desc: 'إتقان قواعد اللغة الكورية مع بناء لغوي متقدم، وتفاصيل للسياقات المهنية والأكاديمية.',
        }
    ],
    zh: [
        {
            title: '你好，韩语！',
            desc: '通过有趣的方式介绍韩语字母表汉字，并学习韩语基本语法结构，启动你的韩语学习之旅。',
        },
        {
            title: '语法基础 101',
            desc: '通过学习基本语言结构、动词和基本句型，建立韩语语法的坚实基础。',
        },
        {
            title: '打破初学者的障碍',
            desc: '高级语法概念、词汇和句子构造技巧，以克服初学者的语法障碍。',
        },
        {
            title: '超越基础，征服韩语！',
            desc: '深入研究复杂的语法模式，句子变化和实用语言使用，以提高流利度。',
        },
        {
            title: '掌握复杂结构',
            desc: '掌握复杂的语法结构、高级动词和微妙的语言表达，以自信地进行沟通。',
        },
        {
            title: '流畅无错的语法',
            desc: '波兰语语法技巧，以便流利运用高级用法、细微差别和精炼表达。',
        },
        {
            title: '成为语法大师',
            desc: '在专业和学术环境中精通韩语语法，具备高级语言结构和细微差别的能力。',
        }
    ],
    fr: [
        {
            title: 'Bonjour, coréen !',
            desc: 'Obtenez une introduction amusante à Hangeul, l\'alphabet coréen, et apprenez la structure de base de la grammaire coréenne pour démarrer votre voyage d\'apprentissage de la langue coréenne.',
        },
        {
            title: 'Fondements de la grammaire 101',
            desc: 'Établissez des bases solides en grammaire coréenne avec des structures de langage essentielles, des verbes et des modèles de phrases de base.',
        },
        {
            title: 'Briser la barrière du débutant',
            desc: 'Concepts avancés de grammaire, vocabulaire et techniques de construction de phrases pour surmonter la barrière de la grammaire débutante.',
        },
        {
            title: 'Au-delà des bases, conquérir le coréen !',
            desc: 'Étude approfondie des modèles de grammaire complexes, des variations de phrases et de l\'utilisation pratique du langage pour une plus grande fluidité.',
        },
        {
            title: 'Maîtriser les Structures Complexes',
            desc: 'Maîtrisez les structures grammaticales complexes, les verbes avancés et les expressions linguistiques nuancées pour une communication confiante.',
        },
        {
            title: 'Grammaire fluide et sans faille',
            desc: 'Compétences en grammaire polonaise pour la fluidité avec une utilisation avancée, les nuances et les expressions raffinées.',
        },
        {
            title: 'Devenez un Maître de la Grammaire',
            desc: 'Maîtrise de la grammaire coréenne avec des constructions linguistiques avancées, des nuances pour les contextes professionnels et académiques.',
        }
    ],
    mn: [
        {
            title: 'Сайн байна уу, корей!',
            desc: 'Хангыгийн, корейн үсгийн танилтайгаа санаачлан санаачлаад, корей хэлний граммарын үндсэн бүтцийг сурахын тулд таны корей хэл сурах аялалыг эхлүүлээрэй.',
        },
        {
            title: 'Грамматик үндэс 101',
            desc: 'Анхны хэлний бүтэцтэй хамтын тодорхой хэлний бүтцийг, глаголууд болон ерөнхий өгүүлбэрийн зурагтай корей хэлний бичигт уулзах.',
        },
        {
            title: 'Эхлэгчийн бохирдлыг тодорхойлох',
            desc: 'Эхлэгчийн грамматикын хоёрдогч, үгийн томъёо, өгүүлбэрийн барилдлыг хөндлөн замыг шинжлэхийн тулд ашиглах техникүүд.',
        },
        {
            title: 'Үндэс дунд болгонд, корейн хэл домогтойгоороо!',
            desc: 'Өргөн хэлний бүтээлийн, өгүүлбэрийн ойролцоо, хэлний хэрэглээг гүйцэтгэхийн тулд гүйцэтгэл хэллэгийг олж мэдрэх.',
        },
        {
            title: 'Хэвийн бүтэцтэйгээ мэдрэх',
            desc: 'Үргэлж хэвийн грамматикийн бүтэцтэйг мастерлах, өргөн глаголуудыг, хэлний илэрхийллийг доголдолтой харилцахад зориулан бүтээлэх.',
        },
        {
            title: 'Алдартай болон хэвийн грамматик',
            desc: 'Ахисан хэрэглээ, дэлгэц болон биеийн мэдлэгийг ашиглан ахисан польш хэлний хэлний шинжээч навчийг дэмжих.',
        },
        {
            title: 'Грамматик шалгаруулах',
            desc: 'Профессионал болон академик сонирхолтоор хэлний боловсруулалтын орчуулгыг ойлгохтой корейн хэлний грамматикийн мэдлэг.',
        }
    ],
    th: [
        {
            title: 'สวัสดี ภาษาเกาหลี!',
            desc: 'รับการแนะนำที่สนุกสนานเกี่ยวกับ Hangeul หรืออักษรเกาหลี และเรียนรู้โครงสร้างพื้นฐานของไวยากรณ์เกาหลีเพื่อเริ่มต้นการเรียนภาษาเกาหลีของคุณได้เลย',
        },
        {
            title: 'พื้นฐานไวยากรณ์ 101',
            desc: 'สร้างพื้นฐานที่แข็งแรงในไวยากรณ์เกาหลีด้วยโครงสร้างภาษาที่สำคัญ คำกริยา และรูปแบบประโยคพื้นฐาน',
        },
        {
            title: 'พลิกฟื้นแกนน้ำของผู้เริ่มต้น',
            desc: 'แนวคิดเรื่องไวยากรณ์ระดับสูง เทคนิคการสร้างคำศัพท์ และเทคนิคการสร้างประโยคเพื่อเอาชนะอุปสรรคของคำไวยากรณ์ของผู้เริ่มต้น',
        },
        {
            title: 'เพื่อง่ายกว่า พิชิตภาษาเกาหลี!',
            desc: 'การศึกษาลึกลับเกี่ยวกับแบบแผนไวยากรณ์ที่ซับซ้อน เทคนิคการเปลี่ยนแปลงประโยคและการใช้ภาษาในชีวิตประจำวันเพื่อให้เก่งและนำไปสู่ความคล่องแคล่วมากยิ่งขึ้น',
        },
        {
            title: 'เชี่ยวชาญโครงสร้างที่ซับซ้อน',
            desc: 'เรียนรู้โครงสร้างไวยากรณ์ที่ซับซ้อน คำกริยาขั้นสูง และการแสดงออกของภาษาที่ละเอียดเพื่อการสื่อสารอย่างมั่นใจ',
        },
        {
            title: 'ไวยากรณ์ที่ถนัดและไม่มีข้อผิดพลาด',
            desc: 'ทักษะภาษาโปแลนด์สำหรับความคล่องแคล่วด้วยการใช้ขั้นสูง ความหมายละเอียดและการแสดงอารมณ์ที่เรียบร้อยแล้ว',
        },
        {
            title: 'เป็นผู้เชี่ยวชาญในการใช้ไวยากรณ์',
            desc: 'ความเชี่ยวชาญในไวยากรณ์เกาหลีด้วยการสร้างภาษาขั้นสูงและเรื่องละเอียดสำหรับบริบททางวิชาการและวิชาชีพ',
        }
    ],
};

const COURSES = {
    latestCourse: {},
    latestLesson: {},
    nextCourse: {},
    nextLesson: {},
    total: 0,
    completed: 0,
    summary: [
        {
            group: 'Starter',
            children: [
                {
                    levelTitle: '0',
                    children: []
                }
            ]
        },
        {
            group: 'Beginner',
            children: [
                {
                    levelTitle: '1',
                    children: []
                },
                {
                    levelTitle: '2',
                    children: []
                }
            ]
        },
        {
            group: 'Intermediate',
            children: [
                {
                    levelTitle: '3',
                    children: []
                },
                {
                    levelTitle: '4',
                    children: []
                }
            ]
        },
        {
            group: 'Advanced',
            children: [
                {
                    levelTitle: '5',
                    children: []
                },
                {
                    levelTitle: '6',
                    children: []
                }
            ]
        }
    ],
    kinds: [
        {
            group: 'Starter',
            desc: 'Embark on Your Korean Language Learning Journey: Beginning with ㄱ, ㄴ, ㄷ!',
            children: [
                {
                    group: 'Starter',
                    levelTitle: '0',
                    title: 'Hello, Korean!',
                    desc: 'Get a fun introduction to Hangeul, the Korean alphabet, and learn basic structure of Korean grammar to kickstart your Korean language learning journey.',
                    period: '7',
                    total: 0,
                    completed: 0,
                    children: [],
                }
            ]
        },
        {
            group: 'Beginner',
            desc: 'Build your Korean foundations for solid language skills!',
            children: [
                {
                    group: 'Beginner',
                    levelTitle: '1',
                    title: 'Grammar Foundations 101',
                    desc: 'Build a solid foundation in Korean grammar with essential language structures, verbs, and basic sentence patterns.',
                    period: '35',
                    total: 0,
                    completed: 0,
                    children: [],
                },
                {
                    group: 'Beginner',
                    levelTitle: '2',
                    title: 'Breaking Beginner\'s Barrier',
                    desc: 'Advanced grammar concepts, vocabulary, and sentence construction techniques to overcome the beginner\'s grammar barrier.',
                    period: '35',
                    total: 0,
                    completed: 0,
                    children: [],
                }
            ]
        },
        {
            group: 'Intermediate',
            desc: 'Level up your Korean skills and speak with confidence!',
            children: [
                {
                    group: 'Intermediate',
                    levelTitle: '3',
                    title: 'Beyond Basics, Conquer Korean!',
                    desc: 'In-depth study of complex grammar patterns, sentence variations, and practical language usage for greater fluency.',
                    period: '40',
                    total: 0,
                    completed: 0,
                    children: [],
                },
                {
                    group: 'Intermediate',
                    levelTitle: '4',
                    title: 'Mastering Complex Structures',
                    desc: 'Master complex grammar structures, advanced verbs, and nuanced language expressions for confident communication.',
                    period: '40',
                    total: 0,
                    completed: 0,
                    children: [],
                }
            ]
        },
        {
            group: 'Advanced',
            desc: 'Master advanced Korean grammar for fluent communication!',
            children: [
                {
                    levelTitle: '5',
                    group: 'Advanced',
                    title: 'Fluent and Flawless Grammar',
                    desc: 'Polish grammar skills for fluency with advanced usage, nuances, and refined expressions.',
                    period: '45',
                    total: 0,
                    completed: 0,
                    children: [],
                },
                {
                    levelTitle: '6',
                    group: 'Advanced',
                    title: 'Be a Grammar Master',
                    desc: 'Expertise in Korean grammar with advanced language constructions, nuances for professional and academic contexts.',
                    period: '45',
                    total: 0,
                    completed: 0,
                    children: [],
                }
            ]
        }
    ]
};

export const overwriteLanguageCourses = (language) => {
    // courseGroups
    // courseContents
    const langs = language || 'en';
    const group = courseGroups[langs];
    const content = courseContents[langs];

    let tempCourses = {...COURSES};

    // tempCourses.summary[0].group = group[0].title;
    // tempCourses.summary[1].group = group[1].title;
    // tempCourses.summary[2].group = group[2].title;
    // tempCourses.summary[3].group = group[3].title;

    // tempCourses.kinds[0].group = group[0].title;
    tempCourses.kinds[0].desc = group[0].desc;

    // tempCourses.kinds[0].children[0].group = group[0].title;
    tempCourses.kinds[0].children[0].title = content[0].title;
    tempCourses.kinds[0].children[0].desc = content[0].desc;

    // tempCourses.kinds[1].group = group[1].title;
    tempCourses.kinds[1].desc = group[1].desc;

    // tempCourses.kinds[1].children[0].group = group[1].title;
    tempCourses.kinds[1].children[0].title = content[1].title;
    tempCourses.kinds[1].children[0].desc = content[1].desc;

    // tempCourses.kinds[1].children[1].group = group[1].title;
    tempCourses.kinds[1].children[1].title = content[2].title;
    tempCourses.kinds[1].children[1].desc = content[2].desc;

    // tempCourses.kinds[2].group = group[2].title;
    tempCourses.kinds[2].desc = group[2].desc;

    // tempCourses.kinds[2].children[0].group = group[2].title;
    tempCourses.kinds[2].children[0].title = content[3].title;
    tempCourses.kinds[2].children[0].desc = content[3].desc;

    // tempCourses.kinds[2].children[1].group = group[2].title;
    tempCourses.kinds[2].children[1].title = content[4].title;
    tempCourses.kinds[2].children[1].desc = content[4].desc;

    // tempCourses.kinds[3].group = group[3].title;
    tempCourses.kinds[3].desc = group[3].desc;

    // tempCourses.kinds[3].children[0].group = group[3].title;
    tempCourses.kinds[3].children[0].title = content[5].title;
    tempCourses.kinds[3].children[0].desc = content[5].desc;

    // tempCourses.kinds[3].children[1].group = group[3].title;
    tempCourses.kinds[3].children[1].title = content[6].title;
    tempCourses.kinds[3].children[1].desc = content[6].desc;

    // return tempCourses;
}

export default COURSES;